import SwaggerUI from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';
import Vue from 'vue';

Vue.component('swagger-component', {
    mounted() {
        SwaggerUI({
            url: '/docs-json',
            dom_id: '#swaggerContainer',
        });
    },
});
